import { useMemo } from 'react';
import { useTestRideDealerDispatch } from '@yme/components/TestRide/useTestRideDealersDispatch';
import { getDealerIdFromUrlList } from '@yme/organisms/test-ride-grid/helpers';
import { useQueryParams } from '@yme/organisms/test-ride-grid/useQueryParams';
export function useTestRideDealers() {
    const { getQueryParams } = useQueryParams({});
    const { dealerId, isIframe } = getQueryParams();
    const dealerIdList = useMemo(() => {
        return getDealerIdFromUrlList(dealerId || '');
    }, [dealerId]);
    const isInIframe = Boolean(isIframe && dealerIdList.length === 1);
    const isInIframeError = Boolean(isIframe && dealerIdList?.length !== 1);
    useTestRideDealerDispatch({
        dealerIdFromUrl: dealerId || '',
        isIframeFromUrl: isIframe || false,
    });
    return {
        isInIframe,
        dealerIdList,
        dealerId,
        isIframe,
        isInIframeError,
    };
}
